module.exports = __webpack_public_path__ + "static/mobile-02-b1009f0eea33a7e4374a2828fbc1a7d3.png";